module.exports = __webpack_public_path__ + "static/media/Asset 34.9799cf73.png";